module.exports = __webpack_public_path__ + "static/media/logo-golden.72cf0a96.png";